import { OrgAdminConstants } from '../../_constants';
import { OrgAdminService } from '../../_services';

export const orgAdminAction = {
    uploadCsvForMembers,
    getOrgTeamHandler,
    addOrgTeamHandler,
    editOrgTeamHandler,
    removeOrgTeamHandler,
    getMemberLevelHandler,
    changeMemberLevelHandler,
    getTeamMemberListHandler,
    moveToDifferentTeamHandler,
    resetTeamLeaderHandler,
    makeTeamLeaderHandler,
    getOrgUsersHandler,
    addPaUsersHandler,
    removePaUsersHandler,
    getPaUserPermissionListHandler,
    changeAccessPaUsersHandler,
    getMasterModuleListhandler,
    getModulePermissionListHandler,
    changeAccessModuleHandler,
    toggleAnalysisHandler,
};


//Upload csv teammembers
function uploadCsvForMembers(data, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.uploadCsvForMembers(data)
            .then(
                csvUploaded => {
                    dispatch(success(csvUploaded));
                    callback(csvUploaded);
                },
                error => {
                    dispatch(failure(error));
                    callback(error);
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_TEAM_CSV_UPLOAD } }
    function success(csvUploaded) { return { type: OrgAdminConstants.RECEIVE_TEAM_CSV_UPLOAD, csvUploaded } }
    function failure(error) { return { type: OrgAdminConstants.ERROR_TEAM_CSV_UPLOAD, error } }
}

//OrgAdmin ORG TEAM starts
function getOrgTeamHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getOrgTeamHandler(id)
            .then(
                getOrgTeam => {
                    dispatch(success(getOrgTeam));
                    callback(getOrgTeam)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_ORG_TEAM } }
    function success(getOrgTeam) { return { type: OrgAdminConstants.RECEIVE_ORG_TEAM, getOrgTeam } }
    function failure(error) { return { type: OrgAdminConstants.ORG_TEAM_ERROR, error } }
}

function addOrgTeamHandler(data, id, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.addOrgTeamHandler(data)
            .then(
                addOrgTeam => {
                    dispatch(success(addOrgTeam));
                    dispatch(getOrgTeamHandler(id, () => { }))
                    callback(addOrgTeam)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_ADD_ORG_TEAM } }
    function success(addOrgTeam) { return { type: OrgAdminConstants.RECEIVE_ADD_ORG_TEAM, addOrgTeam } }
    function failure(error) { return { type: OrgAdminConstants.ADD_ORG_TEAM_ERROR, error } }
}

function editOrgTeamHandler(fd, orgId, teamId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.editOrgTeamHandler(fd, teamId)
            .then(
                editOrgTeam => {
                    dispatch(success(editOrgTeam));
                    dispatch(getOrgTeamHandler(orgId, () => { }))
                    callback(editOrgTeam)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_EDIT_ORG_TEAM } }
    function success(editOrgTeam) { return { type: OrgAdminConstants.RECEIVE_EDIT_ORG_TEAM, editOrgTeam } }
    function failure(error) { return { type: OrgAdminConstants.EDIT_ORG_TEAM_ERROR, error } }
}

function removeOrgTeamHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.removeOrgTeamHandler(fd)
            .then(
                removeOrgTeam => {
                    dispatch(success(removeOrgTeam));
                    dispatch(getOrgTeamHandler(orgId, () => { }))
                    callback(removeOrgTeam)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_REMOVE_ORG_TEAM } }
    function success(removeOrgTeam) { return { type: OrgAdminConstants.RECEIVE_REMOVE_ORG_TEAM, removeOrgTeam } }
    function failure(error) { return { type: OrgAdminConstants.REMOVE_ORG_TEAM_ERROR, error } }
}

//OrgAdmin ORG TEAM ends


//OrgAdmin MEMBER LEVEL starts
function getMemberLevelHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getMemberLevelHandler(id)
            .then(
                getMemberLevel => {
                    dispatch(success(getMemberLevel));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MEMBER_LEVEL } }
    function success(getMemberLevel) { return { type: OrgAdminConstants.RECEIVE_MEMBER_LEVEL, getMemberLevel } }
    function failure(error) { return { type: OrgAdminConstants.MEMBER_LEVEL_ERROR, error } }
}

function changeMemberLevelHandler(data, orgId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.changeMemberLevelHandler(data)
            .then(
                changeMemberLevel => {
                    dispatch(success(changeMemberLevel));
                    dispatch(getMemberLevelHandler(orgId, () => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_CHANGE_MEMBER_LEVEL } }
    function success(changeMemberLevel) { return { type: OrgAdminConstants.RECEIVE_CHANGE_MEMBER_LEVEL, changeMemberLevel } }
    function failure(error) { return { type: OrgAdminConstants.CHANGE_MEMBER_LEVEL_ERROR, error } }
}

//OrgAdmin MEMBER LEVEL ends



//OrgAdmin ORG TEAM MEMBERS starts
function getTeamMemberListHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getTeamMemberListHandler(fd)
            .then(
                getTeamMemberList => {
                    dispatch(success(getTeamMemberList));
                    callback(getTeamMemberList)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_TEAM_MEMBERS_LIST } }
    function success(getTeamMemberList) { return { type: OrgAdminConstants.RECEIVE_TEAM_MEMBERS_LIST, getTeamMemberList } }
    function failure(error) { return { type: OrgAdminConstants.TEAM_MEMBERS_LIST_ERROR, error } }
}

function moveToDifferentTeamHandler(fd, teamId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.moveToDifferentTeamHandler(fd)
            .then(
                moveToDifferentTeam => {
                    dispatch(success(moveToDifferentTeam));
                    const fd1 = {
                        'team_id': +teamId
                    }
                    dispatch(getTeamMemberListHandler(fd1, () => { }));
                    callback(moveToDifferentTeam)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MOVE_TO_DIFFERENT_TEAM } }
    function success(moveToDifferentTeam) { return { type: OrgAdminConstants.RECEIVE_MOVE_TO_DIFFERENT_TEAM, moveToDifferentTeam } }
    function failure(error) { return { type: OrgAdminConstants.MOVE_TO_DIFFERENT_TEAM_ERROR, error } }
}

function resetTeamLeaderHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.resetTeamLeaderHandler(fd)
            .then(
                resetTeamLeader => {
                    dispatch(success(resetTeamLeader));
                    // const fd1 = {
                    //     'team_id': +orgId
                    // }
                    // dispatch(getTeamMemberListHandler(fd1, () => { }))
                    callback(resetTeamLeader)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_RESET_TEAM_LEADER } }
    function success(resetTeamLeader) { return { type: OrgAdminConstants.RECEIVE_RESET_TEAM_LEADER, resetTeamLeader } }
    function failure(error) { return { type: OrgAdminConstants.RESET_TEAM_LEADER_ERROR, error } }
}

function makeTeamLeaderHandler(fd, teamId, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.makeTeamLeaderHandler(fd)
            .then(
                makeTeamLeader => {
                    dispatch(success(makeTeamLeader));
                    // const fd1 = {
                    //     'team_id': +teamId
                    // }
                    // dispatch(getTeamMemberListHandler(fd1, () => { }))
                    callback(makeTeamLeader)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MAKE_TEAM_LEADER } }
    function success(makeTeamLeader) { return { type: OrgAdminConstants.RECEIVE_MAKE_TEAM_LEADER, makeTeamLeader } }
    function failure(error) { return { type: OrgAdminConstants.MAKE_TEAM_LEADER_ERROR, error } }
}

//OrgAdmin ORG TEAM MEMBERS ends

//OrgAdmin PA USERS starts
function getOrgUsersHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getOrgUsersHandler(id)
            .then(
                getOrgUsers => {
                    dispatch(success(getOrgUsers));

                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_ORG_USERS } }
    function success(getOrgUsers) { return { type: OrgAdminConstants.RECEIVE_ORG_USERS, getOrgUsers } }
    function failure(error) { return { type: OrgAdminConstants.ORG_USERS_ERROR, error } }
}

function addPaUsersHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.addPaUsersHandler(data)
            .then(
                addPaUsers => {
                    dispatch(success(addPaUsers));
                    dispatch(getOrgUsersHandler(data.organisation_id, () => { }))
                    callback(addPaUsers)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_ADD_PA_USERS } }
    function success(addPaUsers) { return { type: OrgAdminConstants.RECEIVE_ADD_PA_USERS, addPaUsers } }
    function failure(error) { return { type: OrgAdminConstants.ADD_PA_USERS_ERROR, error } }
}

function removePaUsersHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.removePaUsersHandler(data)
            .then(
                removePaUsers => {
                    dispatch(success(removePaUsers));
                    dispatch(getOrgUsersHandler(data.organisation_id, () => { }))
                    callback(removePaUsers)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)

                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_REMOVE_PA_USERS } }
    function success(removePaUsers) { return { type: OrgAdminConstants.RECEIVE_REMOVE_PA_USERS, removePaUsers } }
    function failure(error) { return { type: OrgAdminConstants.REMOVE_PA_USERS_ERROR, error } }
}

function getPaUserPermissionListHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getPaUserPermissionListHandler(data)
            .then(
                getPaUserPermissionList => {
                    dispatch(success(getPaUserPermissionList));
                    callback(getPaUserPermissionList)
                },
                error => {
                    dispatch(failure(error));
                    callback()
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_PA_USER_PERMISSIONS_LIST } }
    function success(getPaUserPermissionList) { return { type: OrgAdminConstants.RECEIVE_PA_USER_PERMISSIONS_LIST, getPaUserPermissionList } }
    function failure(error) { return { type: OrgAdminConstants.PA_USER_PERMISSIONS_LIST_ERROR, error } }
}

function changeAccessPaUsersHandler(fd, type, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.changeAccessPaUsersHandler(fd, type)
            .then(
                changeAccess => {
                    dispatch(success(changeAccess));
                    callback(changeAccess)
                    },
                        error => {
                        dispatch(failure(error));
                        callback(error)
                    }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_CHANGE_ACCESS } }
    function success(changeAccess) { return { type: OrgAdminConstants.RECEIVE_CHANGE_ACCESS, changeAccess } }
    function failure(error) { return { type: OrgAdminConstants.CHANGE_ACCESS_ERROR, error } }
}

function getMasterModuleListhandler(callback){
    return dispatch => {
        dispatch(request());
        OrgAdminService.getMasterModuleListhandler()
            .then(
                getMasterModuleList => {
                    dispatch(success(getMasterModuleList));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                    callback()
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MASTER_MODULE_LIST } }
    function success(getMasterModuleList) { return { type: OrgAdminConstants.RECEIVE_MASTER_MODULE_LIST, getMasterModuleList } }
    function failure(error) { return { type: OrgAdminConstants.MASTER_MODULE_LIST_ERROR, error } }
}


function getModulePermissionListHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.getModulePermissionListHandler(data)
            .then(
                getModulePermissionList => {
                    dispatch(success(getModulePermissionList));
                    callback(getModulePermissionList)
                },
                error => {
                    dispatch(failure(error));
                    callback()
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MODULE_PERMISSIONS_LIST } }
    function success(getModulePermissionList) { return { type: OrgAdminConstants.RECEIVE_MODULE_PERMISSIONS_LIST, getModulePermissionList } }
    function failure(error) { return { type: OrgAdminConstants.MODULE_PERMISSIONS_LIST_ERROR, error } }
}

function changeAccessModuleHandler(fd, type, callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.changeAccessModuleHandler(fd, type)
            .then(
                changeAccess => {
                    dispatch(success(changeAccess));
                    callback(changeAccess)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_MODULE_CHANGE_ACCESS } }
    function success(changeAccess) { return { type: OrgAdminConstants.RECEIVE_MODULE_CHANGE_ACCESS, changeAccess } }
    function failure(error) { return { type: OrgAdminConstants.MODULE_CHANGE_ACCESS_ERROR, error } }
}

function toggleAnalysisHandler(callback) {
    return dispatch => {
        dispatch(request());
        OrgAdminService.toggleAnalysisHandler()
            .then(
                toggleAnalysis => {
                    dispatch(success(toggleAnalysis));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OrgAdminConstants.REQUEST_TOGGLE_ANALYSIS } }
    function success(toggleAnalysis) { return { type: OrgAdminConstants.RECEIVE_TOGGLE_ANALYSIS, toggleAnalysis } }
    function failure(error) { return { type: OrgAdminConstants.TOGGLE_ANALYSIS_ERROR, error } }
}

//OrgAdmin PA USERS ends



// WEBPACK FOOTER //
// ./src/_actions/OrgAdmin/orgAdmin.action.js